import { useContext } from 'react';
import { TrackerContext } from '@unite-us/client-utils';

const useTrackEvent = () => {
    const trackEvent = useContext(TrackerContext);

    const trackEventData = (pageName, eventData) => {
      if (!pageName || !eventData) {
        // eslint-disable-next-line no-console
        console.error('page name or event data is undefined');
      }
      trackEvent(pageName, eventData);
    };
    return trackEventData;
};

export default useTrackEvent;
